module.exports = __webpack_public_path__ + "img/crashBanners.ca6f839f.jpg";